module.exports = __webpack_public_path__ + "static/media/tutorial-start-step1.645823ca.png";